import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const contactsAdapter = getAdapter({ idFieldName: 'id' });

const contactsSlice = createSlice({
  name: 'contacts',
  initialState: contactsAdapter.getInitialState(),
  reducers: {
    setContacts: (state, { payload: { contacts } }) => {
      contactsAdapter.setAll(state, contacts);
    }
  }
});

const selectors = contactsAdapter.getSelectors(({ contacts }) => contacts);

export const getContacts = state => selectors.selectAll(state);

export const { setContacts } = contactsSlice.actions;

export default contactsSlice.reducer;
